/**
  * @param {string} prefix
  * @param {string} id
  */
export const tagOrNull = (prefix, id) => (id ? `${prefix}-${id}` : null);
